namespace Solovis.Reports.Parts.Tables.DataTableHelpers {


    export class Column {

        public columnSet: ColumnSet;

        public _col;

        public definition;
        public id;
        public field;
        public dataType;
        public label;
        public superHeaders;
        public hiddenByDefault;

        public mods;        

        public definitionToUse;


        constructor(options) {
            this.columnSet = options.columnSet;

            this._col = options.column ? options.column : null;
            if (!this._col) {
                throw "column not defined";
            }

            this.definition = this._col;

            this.id = this._col.id;
            this.field = this._col.field ? this._col.field : null;
            this.dataType = this._col.dataType ? this._col.dataType : null;
            this.label = this._col.label;
            this.superHeaders = this._col.superHeaders ? this._col.superHeaders : null;
            this.hiddenByDefault = this._col.hiddenByDefault ? this._col.hiddenByDefault : false;

            this.mods = options.mods ? options.mods : null;

            this._updateDefinitionToUse();
        }


        /**
         * updateMods changes the modifications applied to a column definition.
         * @param mods
         * @param suppressColumnChangedEvent
         */
        public updateMods(mods, suppressColumnChangedEvent?) {
            this.mods = mods;
            this._updateDefinitionToUse();

            if (!suppressColumnChangedEvent) {
                this.columnSet.notifyColumnsChanged({
                    columnId: this.id,
                    modsUpdated: true
                });
            }
        }


        public _updateDefinitionToUse() {
            var definitionToUse: any = {};

            for (var key in this.definition) {
                var value = this.definition[key];

                if (key == "formatHint") {
                    // We deepCopy formatHint since we will change nested properties on that with mods.
                    value = Solovis.deepCopy(value);
                }

                definitionToUse[key] = value;
            }

            // We whitelist the available mods below.
            if (this.mods) {
                if (Solovis.isNotNull(this.mods.label)) {
                    definitionToUse.label = this.mods.label;
                }

                if (Solovis.isNotNull(this.mods.superHeaders)) {
                    definitionToUse.superHeaders = Solovis.deepCopy(this.mods.superHeaders);
                }

                if (Solovis.isNotNull(this.mods.width)) {
                    definitionToUse.width = this.mods.width;
                }

                if (Solovis.isNotNull(this.mods.textAlign)) {
                    definitionToUse.textAlign = this.mods.textAlign;
                }

                if (Solovis.isNotNull(this.mods.headerAlign)) {
                    definitionToUse.headerAlign = this.mods.headerAlign;
                }

                if (Solovis.isNotNull(this.mods.noWrap)) {
                    definitionToUse.noWrap = this.mods.noWrap;
                }

                if (this.mods.formatHint) {
                    if (!definitionToUse.formatHint) {
                        definitionToUse.formatHint = {};
                    }

                    if (Solovis.isNotNull(this.mods.formatHint.scale)) {
                        definitionToUse.formatHint.scale = parseInt(this.mods.formatHint.scale);
                    }
                }

                if (Solovis.isNotNull(this.mods.applyStandardGrouping)) {
                    definitionToUse.applyStandardGrouping = this.mods.applyStandardGrouping;
                }

                if (this.mods.aggregation) {
                    // aggregation should have an aggregator property with value of "sum" or other supported aggregation method.
                    definitionToUse.aggregation = Solovis.deepCopy(this.mods.aggregation);

                    // We apply a custom htmlFormatter wrapper to handle counting aggregator.
                    var aggregator = definitionToUse.aggregation.aggregator;
                    if (aggregator === "count" || aggregator === "countIfNotNull" || aggregator === "uniqueCount" || aggregator === "uniqueCountIfNotNull") {
                        var baseFormatter = definitionToUse.htmlFormatter;
                        definitionToUse.htmlFormatter = function (value, valueContext) {
                            if (valueContext.aggregate) {
                                // Show the count as an integer.
                                if (typeof value == "number") {
                                    return value.toString();
                                }
                                else {
                                    return null;
                                }
                            }

                            if (baseFormatter) {
                                return baseFormatter(value, valueContext);
                            }
                            else {
                                return valueContext.defaultFormatter(value, valueContext);
                            }
                        };
                    }
                }
            }

            // See if we need to apply a default for text-alignment.
            if (Solovis.isNull(definitionToUse.textAlign)) {
                var dataType = this.dataType;
                if (dataType == "dayId" || dataType == "bool" || dataType == "currencyId") {
                    definitionToUse.textAlign = "center";
                }
                else if (dataType == "number" || dataType == "currency" || dataType == "integer" || dataType == "percentage") {
                    definitionToUse.textAlign = "right";
                }
            }

            // See if we need to apply a default for width.
            if (Solovis.isNull(definitionToUse.width)) {
                if (dataType == "dayId") {
                    definitionToUse.width = 105;
                }
                else if (dataType == "currencyId") {
                    definitionToUse.width = 65;
                }
                else if (dataType == "percentage") {
                    definitionToUse.width = 75;
                }
                else if (dataType == "currency" || dataType == "number") {
                    definitionToUse.width = 115;
                }
                else if (dataType == "integer") {
                    definitionToUse.width = 90;
                }
                else if (dataType == "utcTimestamp") {
                    definitionToUse.width = 175;
                }
                else {
                    definitionToUse.width = 150;
                }
            }

            this.definitionToUse = definitionToUse;
        }

        public getCompositeLabel() {
            var colDef = this.definitionToUse;

            var label = colDef.label;
            if (colDef.superHeaders && colDef.superHeaders.length > 0) {
                for (var i = 0; i < colDef.superHeaders.length; i++) {
                    label = colDef.superHeaders[i] + " : " + label;
                }
            }

            return label;
        }
    }

}
